import { useState } from 'react';
import { GeoJsonLayer, PickingInfo } from 'deck.gl/typed';
import { useTheme } from '@mui/material';

import { DeckMap, defaultGeoJsonLayerProps } from './DeckMap';
import { COUNTIES_URL, FIPSDetails } from 'common';

export interface CountiesMapProps {
  selectedCounties?: FIPSDetails[];
  layerProps?: any;
}

export const CountiesMap = ({ selectedCounties, layerProps }: CountiesMapProps) => {
  const theme = useTheme();
  const [hoverInfo, setHoverInfo] = useState<PickingInfo>();

  return (
    <DeckMap
      hoverInfo={hoverInfo}
      renderTooltipContent={(info: PickingInfo) =>
        `${info.object.properties?.NAME} (${info.object.properties?.GEOID})`
      }
      layers={[
        new GeoJsonLayer({
          ...defaultGeoJsonLayerProps,
          id: `geojson-layer-counties`,
          data: COUNTIES_URL,
          highlightColor: theme.palette.mode === 'dark' ? [255, 255, 255, 25] : [80, 144, 211, 20],
          getLineColor: theme.palette.mode === 'dark' ? [255, 255, 255, 200] : [178, 186, 194, 200],
          getFillColor: (f) =>
            !!selectedCounties?.some(
              (c: FIPSDetails) => `${c.stateFP}${c.countyFP}` === f.properties?.GEOID
            )
              ? [0, 125, 255, 50]
              : [255, 255, 255, 20],
          updateTriggers: {
            getFillColor: [selectedCounties],
          },
          onHover: (info: PickingInfo) => setHoverInfo(info),
          ...layerProps,
        }),
      ]}
    />
  );
};
